import { useState } from "react";
import { ScaleLoader } from "react-spinners";
import { getMainTheme } from "../../../../core/utils/theme";
import { CFlex, Column, DeleteIcon, Flex, Row } from "../../../../styles/CommonStyles";
import Text from "../../../../core/utils/Text";
import { EditIcon } from "../../../../styles/main/setting";
import ModalLayout from "../../../layout/main/ModalLayout";
import PairCategoryModal from "./PairCategoryModal";
import { useGetCategories } from "../../../../core/services/react-query/setting/category"; // ✅ adjust path as needed

// Define headers and column structure similar to CoinCategory
const categoryAttributes = {
  headers: [
    { title: "label" },
    { title: "emoji" },
    { title: "list" },
    { title: "status" },
    { title: "action" },
  ],
  cs: "1fr 0.5fr 2fr 0.6fr 0.5fr",
};

const PairCategoryListing = ({ categories, isLoading }) => {
  const { headers, cs } = categoryAttributes;

  const initial = { show: false, category: null, type: "edit" };
  const [catModal, setCatModal] = useState(initial);

  const closeCatModal = () => setCatModal(initial);
  const openCatModal = (cat, type = "edit") => setCatModal({ show: true, category: cat, type });

  return (
    <>
      <CFlex fw>
        {isLoading ? (
          <Flex height={"300px"}>
            <ScaleLoader color={getMainTheme().active} />
          </Flex>
        ) : (
          <>
            <Row cs={cs} header={1}>
              {headers.map((h) => (
                <Column key={h.title}>
                  <Text tid={h.title} />
                </Column>
              ))}
            </Row>

            {categories?.map((cat, idx) => (
              <Row cs={cs} index={idx} key={cat.label} noHover={1}>
                <Column>{cat.label}</Column>
                <Column>{cat.emoji || "—"}</Column>
                <Column>
                  <Flex fw wrap justify={"flex-start"}>
                    {cat?.list?.map((item, i) => (
                      <Flex
                        key={i}
                        style={{
                          border: "1px solid #444",
                          borderRadius: "6px",
                          padding: "2px 6px",
                          margin: "2px",
                          fontSize: "12px",
                        }}
                      >
                        {item.ticker}
                      </Flex>
                    ))}
                  </Flex>
                </Column>
                <Column>
                  {cat.isActive ? (
                    <Text tid={"active"} color={"green"} />
                  ) : (
                    <Text tid={"inactive"} color={"red"} />
                  )}
                </Column>
                <Flex gap="8px">
                  <EditIcon size={22} onClick={() => openCatModal(cat, "edit")} />
                  <DeleteIcon
                    size={22}
                    color="#d33"
                    onClick={() => openCatModal(cat, "delete")}
                  />
                </Flex>
              </Row>
            ))}
          </>
        )}
      </CFlex>

      <ModalLayout width={"620px"} open={catModal.show} onClose={closeCatModal}>
        <PairCategoryModal
          onSuccess={closeCatModal}
          _category={catModal.category}
          existingCategories={categories}
          type={catModal.type}

        />
      </ModalLayout>
    </>
  );
};

export default PairCategoryListing;
